import "../sass/main.scss";
import "./alpine"

import.meta.glob('./*.js' , {
    eager: true,
});


// FontAwesome with tree-shake ability - add only the icons we need for the project
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faChevronLeft, faChevronRight, faChevronDown, faMinus, faPlus, faMagnifyingGlass, faX, faXmark, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { faEyeSlash, faEye } from '@fortawesome/free-regular-svg-icons'

// Brand icons
import {
    faFacebookF,
    faTwitter,
    faYoutube,
    faInstagram,
    faPinterestP
  } from '@fortawesome/free-brands-svg-icons';

library.add(
    faX,
    faXmark,
    faMagnifyingGlass,
    faPlus,
    faMinus,
    faEye,
    faEyeSlash,
    faChevronLeft, 
    faChevronRight,
    faChevronDown,
    faFacebookF,
    faTwitter,
    faYoutube,
    faInstagram, 
    faPinterestP,
    faArrowRight
)
dom.watch(); // This will kick of the replacement of i tags with an SVG
